import Datatable from "../../Components/Datatable"
import React, { useEffect, useState } from "react";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useAuth } from '../../../../../context/AuthContext';
import { API_BASE_URL, EXPRESS_BASE_URL } from "../../../../../Helpers/apiConfig";

const AcceptIcon = ({ accepted }) => (
    <FontAwesomeIcon
        icon={accepted ? "fas fa-check-circle" : "fas fa-times-circle"}
        style={{ color: accepted ? "green" : "#dc3545", fontSize: "18px" }}
    />
);

// Secilen okula ait CorporateUsersAcceptance kayitlarini listeler; type'a
// gore (0 = ogrenci, 1 = ogretmen) ikiye ayirma UI tarafinda yapiliyor.
export const AdminCorporateAcceptanceList = () => {
    const { user } = useAuth();
    const [schools, setSchools] = useState([]);
    const [selectedSchoolId, setSelectedSchoolId] = useState("");
    const [teachers, setTeachers] = useState([]);
    const [students, setStudents] = useState([]);
    const [loading, setLoading] = useState(false);
    const [schoolsLoading, setSchoolsLoading] = useState(true);
    const [msg, setMsg] = useState("");
    const [searched, setSearched] = useState(false);

    const columns = React.useMemo(
        () => [
            {
                Header: "İsim",
                Footer: "İsim",
                accessor: 'name',
            },
            {
                Header: "E-posta",
                Footer: "E-posta",
                accessor: 'email',
            },
            {
                Header: "Tarih",
                Footer: "Tarih",
                accessor: 'tarihText',
            },
            {
                Header: "KVKK",
                Footer: "KVKK",
                accessor: (row) => <AcceptIcon accepted={!!row.kvkkRaw} />,
                id: 'kvkk',
            },
            {
                Header: "Üyelik Sözleşmesi",
                Footer: "Üyelik Sözleşmesi",
                accessor: (row) => <AcceptIcon accepted={!!row.sozlesmeRaw} />,
                id: 'sozlesme',
            },
        ],
        [],
    )

    useEffect(() => {
        const fetchSchools = async () => {
            setSchoolsLoading(true);
            try {
                const headerss = {
                    "accept": "*/*",
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Credentials': 'false',
                    'Authorization': 'Bearer ' + user.token
                };
                const res = await axios({
                    method: 'GET',
                    url: `${API_BASE_URL}/admin/School/SchoolList`,
                    headers: headerss
                });
                if (res.status === 200 && res.data['success']) {
                    const activeSchools = (res.data['data'] || []).filter((s) => !s.isDeleted);
                    setSchools(activeSchools);
                } else {
                    setMsg("Okul listesi alınamadı.");
                }
            } catch (err) {
                setMsg("Okul listesi alınamadı.");
            }
            setSchoolsLoading(false);
        };
        fetchSchools();
    }, [user.token]);

    const handleFetch = async (e) => {
        e.preventDefault();
        if (!selectedSchoolId) return;
        setLoading(true);
        setSearched(true);
        try {
            const headerss = {
                "accept": "*/*",
                'Content-Type': 'application/json',
                'Access-Control-Allow-Credentials': 'false',
                'Access-Control-Allow-Origin': '*',
            };
            const res = await axios({
                method: 'get',
                url: `${EXPRESS_BASE_URL}/getcorporateacceptancebyschoolid/${selectedSchoolId}`,
                headers: headerss
            });

            const rows = Array.isArray(res.data) ? res.data : [];
            const mapped = rows.map((row) => {
                const tarihDate = row.tarih ? new Date(row.tarih) : null;
                return {
                    name: row.name,
                    email: row.email,
                    tarihText: tarihDate ? tarihDate.toLocaleString("tr-TR") : "-",
                    kvkkRaw: row.kvkk,
                    sozlesmeRaw: row.sozlesme,
                    typeRaw: Number(row.type),
                };
            });
            setTeachers(mapped.filter((r) => r.typeRaw === 1));
            setStudents(mapped.filter((r) => r.typeRaw === 0));
        } catch (err) {
            setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
        }
        setLoading(false);
    };

    return (
        <div>
            <div style={{ textAlign: "center" }}>
                <h1>Üyelik Kabulleri</h1>
            </div>
            <h4>{msg}</h4>

            <form onSubmit={handleFetch} className="d-flex align-items-end gap-2 mb-4" style={{ maxWidth: "500px" }}>
                <div className="flex-grow-1">
                    <label htmlFor="acceptanceSchoolSelect" className="form-label">Okul Seç</label>
                    <select
                        id="acceptanceSchoolSelect"
                        className="form-select"
                        value={selectedSchoolId}
                        onChange={(e) => setSelectedSchoolId(e.target.value)}
                        disabled={schoolsLoading}
                        required
                    >
                        <option value="">{schoolsLoading ? "Okullar yükleniyor..." : "Seçiniz"}</option>
                        {schools.map((s) => (
                            <option key={s.id} value={s.id}>{s.schoolName}</option>
                        ))}
                    </select>
                </div>
                <button type="submit" className="btn btn-primary" disabled={!selectedSchoolId || loading}>
                    Getir
                </button>
            </form>

            {loading && <div>Veriler Yükleniyor!</div>}

            {!loading && searched && (
                <div>
                    <h3>Öğretmenler</h3>
                    <Datatable data={teachers} columns={columns} tableBaslik="Öğretmenler" />

                    <h3 className="mt-5">Öğrenciler</h3>
                    <Datatable data={students} columns={columns} tableBaslik="Öğrenciler" />
                </div>
            )}
        </div>
    );
};
export default AdminCorporateAcceptanceList;
